import { Component } from '@angular/core';
import { SharedService } from '../shared.service';
import { AuthService } from 'src/app/core/services/auth.service';
@Component({
  selector: 'app-bs-sidebar',
  templateUrl: './bs-sidebar.component.html',
  styleUrls: ['./bs-sidebar.component.css']
})
export class BsSidebarComponent {
  linkViewAccess: any = [];
  constructor(
    public sharedService: SharedService,
    public authService: AuthService
  ) {}
  ngOnInit(): void {
    this.getAccessPermissioins();
  }
  toggleSidebar(event?: MouseEvent) {
    if (event) event.stopPropagation();
    this.sharedService.isToggleSidebar = !this.sharedService.isToggleSidebar;
  }
  getAccessPermissioins() {
    if (this.authService.userPermisions?.length < 1) {
      this.authService.loadLoginUserPermissions();
    }
    this.linkViewAccess = this.authService.userPermisions
      .filter((p: any) => p.access.includes('view'))
      .map((x: any) => x.module);
  }
  isLinkVisible(module: string) {
    //Todo : implement generic - start
    if(module == 'product'){ //console.log('***');
      //if(this.authService.Permisions.length ==1 && this.authService.Permisions.includes('royalty.all'))
      if(this.authService.loginUserRoles.length ==1 && this.authService.loginUserRoles[0].name =='Royalty Manager')
        return false;
      else
        return true; 
    }
    //End
    if (!this.authService.Permisions || this.authService.Permisions.length < 1) return false;
    if (this.authService.Permisions.includes('all')) return true;
    if (this.authService.Permisions.includes('view')) return true;
    if (
      this.authService.Permisions.includes(`${module}.all`) ||
      this.authService.Permisions.includes(`${module}.view`)
    )
      return true;
    return false;
  }
}